import React, { memo } from "react";
import { Box } from "@UI/Components/Box/Box";
import { Text } from "@UI/Components/Text/Text";
import { Link } from "@UI/Components/Link/Link";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";

interface PrivateTaskNoResponseBannerProps {
  spName: string;
  postTaskHref: string;
}

export const PrivateTaskNoResponseBanner = memo(
  ({ spName, postTaskHref }: PrivateTaskNoResponseBannerProps) => {
    return (
      <Box w="full" bg="orange.100" borderRadius="10px" px={4} py={3} mt="2rem !important">
        <Text m="0" fontSize="md" color="gray.800">
          <FormattedMessage
            {...messages["serviceRequest.candidates.private.noResponse.sent"]}
            values={{ spName }}
          />
        </Text>
        <Text m="0" fontSize="md" color="gray.800">
          <FormattedMessage
            {...messages["serviceRequest.candidates.private.noResponse.postTask"]}
            values={{
              postTaskLink: (
                <Link href={postTaskHref} color="pink.500" textDecoration="underline">
                  <FormattedMessage
                    {...messages["serviceRequest.candidates.private.noResponse.postTaskLink"]}
                  />
                </Link>
              ),
            }}
          />
        </Text>
      </Box>
    );
  }
);

PrivateTaskNoResponseBanner.displayName = "PrivateTaskNoResponseBanner";
